import caretDownIcon from "../../Retrofit/Assets/Sizing/caret-down.svg";

const CustomSelect = ({ name, unitVal, handleInputChange, options }) => {
  return (
    <div className="relative w-[160px] text-sm mt-[8px] ml-2 mb-2 mr-5">
      <select
        className="w-full py-1 px-2 text-sm cursor-pointer text-gray-600 border-gray-300 rounded-md appearance-none"
        name={`${name}Unit`}
        id={`${name}Unit`}
        value={unitVal}
        onChange={handleInputChange}
        style={{
          background: "none",
          WebkitAppearance: "none",
          MozAppearance: "none",
          appearance: "none"
        }}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
        <img src={caretDownIcon} alt="Caret Down" className="w-3 h-3" />
      </div>
    </div>
  );
};

export default CustomSelect;
